import React from "react"
import Img from "gatsby-image"
import classnames from "classnames/bind"
// Style
import twoColumnStyle from "../../style/components/projects/two-column.module.scss"

const TwoColumnHeading = props => {
  return pug`
    div.flex.justify-center.items-start.flex-row.row(className=classnames(twoColumnStyle.wrapper, props.className))
      div.col-12.col-md-6.pl-0.text-center.flex.flex-col(className=twoColumnStyle.image_wrapper)
        Img(fluid=props.image_url alt=props.image_alt style={ height:'100%', width:'100%' })
        p.mt-3.txt-caption.text-gray-200=props.image_alt
      div.col-12.col-md-6.flex.justify-center.items-center.flex-col.pr-0(className=twoColumnStyle.text_wrapper)
        if  (props.num)
          div.col-12.mb-1.px-0(className=twoColumnStyle.text_subtitle)
            span(className=props.darkmode?"text-theme-300":"text-gray-100")=props.num
        if (props.heading)
          div.col-12.mb-10.px-0(className=twoColumnStyle.text_heading)
            span(className=props.darkmode?"text-theme-100":"text-gray-100")=props.heading
        if (props.title)
          div.col-12.mb-4.px-0(className=twoColumnStyle.text_title)
            span(className=props.darkmode?"text-theme-100":"text-gray-100")=props.title
        if (props.content)
          div.col-12.px-0(className=twoColumnStyle.text_content)
            p(className=props.darkmode?"text-theme-200":"text-gray-200")=props.content
        ${props.children}
  `
}

const TwoColumnTitle = props => {
  return pug`
    if (props.title)
      div.col-12.mb-4.px-0(className=classnames(twoColumnStyle.text_title,twoColumnStyle.wrapper_title, props.title?props.className:''))
        span(className=props.darkmode?"text-theme-100":"text-gray-100")=props.title
    if (props.content)
      div.col-12.px-0(className=classnames(twoColumnStyle.text_content, props.title?'':props.className))
        p(className=props.darkmode?"text-theme-200":"text-gray-200")=props.content

  `
}

export { TwoColumnHeading, TwoColumnTitle }
